module.exports = __webpack_public_path__ + "media/slot-game/hand-finder-548f6383.svg";